import SectionHeading from '@/components/base/SectionHeading';
import ArticleLink from '@/components/feature/ArticleLink';
import ScrollReveal from '@/components/base/ScrollReveal';
import IndicatorVisual from '@/pages/forex-analysis/components/IndicatorVisual';
import { analysisIndicators } from '@/mocks/forexAnalysisPage';

const tones = [
  { chip: 'bg-primary-100 text-primary-800', head: 'text-primary-700', label: 'MA 20' },
  { chip: 'bg-accent-100 text-accent-800', head: 'text-accent-700', label: 'RSI 14' },
  { chip: 'bg-secondary-100 text-secondary-900', head: 'text-secondary-700', label: 'MACD 12 26 9' },
];

export default function IndicatorShowcase() {
  return (
    <section id="indicators" className="scroll-mt-[7.5rem] md:scroll-mt-[9rem] border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between lg:gap-12">
          <SectionHeading
            eyebrow="อินดิเคเตอร์"
            title="รู้จักอินดิเคเตอร์ที่ใช้ในการวิเคราะห์ Forex"
            subtitle="สามเครื่องมือที่มือใหม่เจอบ่อยที่สุด พร้อมภาพประกอบว่ามันหน้าตาอย่างไรบนกราฟ และควรใช้เป็นตัวช่วยแบบไหน"
          />
          <p className="max-w-xs shrink-0 text-xs leading-relaxed text-foreground-600 lg:pb-2">
            อินดิเคเตอร์ทุกตัวคำนวณจากราคาในอดีต จึงช่วยจัดลำดับความน่าจะเป็นได้ แต่ไม่สามารถยืนยันอนาคตได้
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:mt-12 md:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {analysisIndicators.map((indicator, index) => {
            const tone = tones[index];
            return (
              <ScrollReveal
                as="article"
                key={indicator.id}
                delay={index * 80}
                className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 md:p-6"
              >
                <div className="flex items-center justify-between gap-3">
                  <h3 className={`font-heading text-lg font-semibold ${tone.head}`}>{indicator.name}</h3>
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${tone.chip}`}>
                    {indicator.tag}
                  </span>
                </div>

                <div className="mt-4 rounded-lg border border-background-200 bg-background-100/70 p-3">
                  <div className="flex items-center justify-between px-1 pb-1">
                    <span className="font-num text-[10px] font-semibold uppercase tracking-wide text-foreground-500">
                      {tone.label}
                    </span>
                    <span className="text-[10px] text-foreground-400">ภาพประกอบ</span>
                  </div>
                  <div className="h-24 w-full">
                    <IndicatorVisual id={indicator.id} series={indicator.series} />
                  </div>
                </div>

                <p className="mt-4 text-[13px] leading-relaxed text-foreground-600">{indicator.description}</p>

                <p className="mt-3 flex items-start gap-2 rounded-md bg-background-100/70 px-2.5 py-2 text-[11px] leading-relaxed text-foreground-600">
                  <i className="ri-error-warning-line mt-0.5 shrink-0 text-sm text-accent-600" aria-hidden="true" />
                  {indicator.note}
                </p>

                <ArticleLink
                  to={`/${indicator.slug}`}
                  className="group/link mt-auto flex items-center gap-1.5 border-t border-background-200 pt-3 text-xs font-semibold text-primary-700 transition-colors hover:text-primary-800"
                  aria-label={`อ่านบทความเกี่ยวกับ ${indicator.name}`}
                >
                  อ่านบทความที่เกี่ยวข้อง
                  <i
                    className="ri-arrow-right-line text-sm transition-transform group-hover/link:translate-x-0.5"
                    aria-hidden="true"
                  />
                </ArticleLink>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}